import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const images = [
  '/assets/go21.jpg',
  '/assets/go22.jpg',
  '/assets/go24.jpg',
  '/assets/go25.jpg'
];

export const Hero: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative bg-gray-900 text-white overflow-hidden h-[600px] flex items-center">
      <div className="absolute inset-0">
        {images.map((src, index) => (
          <img 
            key={src}
            src={src} 
            alt="Travel Background" 
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${index === currentIndex ? 'opacity-60' : 'opacity-0'}`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full z-10">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-4 uppercase">
            Go2 Legende
          </h1>
          <p className="text-3xl md:text-4xl font-script text-go2-yellow mb-8 transform -rotate-2 origin-left">
            od putnika do legende
          </p>
          
          <p className="text-xl text-gray-200 mb-10 max-w-lg leading-relaxed">
            Sakupljaj bodove na svakom putovanju sa Go2, otključaj više nivoe i ostvari do 40% popusta koristeći svoje bodove.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Link 
              to="/go2-legende/dashboard" 
              className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-bold rounded-full text-white bg-go2-pink hover:bg-brand-600 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 uppercase tracking-wider"
            >
              Prijavi se
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
            <a 
              href="#how-it-works" 
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-base font-bold rounded-full text-white hover:bg-white hover:text-brand-900 transition-all uppercase tracking-wider"
            >
              Kako funkcioniše
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
